export default __webpack_public_path__ + "images/300b62e7386fa06ec316ea3b1dea2f42.png";